import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { User } from '../user/user';
import { UserService } from '../_services/user.service'


@Component({
    templateUrl: 'home.component.html',
    styleUrls: ['home.less', '../app.component.less']
})
export class HomeComponent implements OnInit {
    currentUser: User;
    users: User[] = [];

    constructor(private userService: UserService) {
        this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    }

    // PAGE LOAD
    ngOnInit() {

        //this.loadAllUsers();
    }
    // GELETE USER BY ID
    deleteUser(id: number) {
        this.userService.delete(id).pipe(first()).subscribe(() => {
            this.loadAllUsers()
        });
    }

    // GET ALL USERS
    private loadAllUsers() {
        this.userService.getAll().subscribe(users => {
            this.users = users;
        });
    }
}